<script>

import axios from 'axios'

export default {
  props: {
    id: {
      type: String,
      default: 'owntable'
    },
    source: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    start: {
      type: Number,
      default: 0
    },
    end: {
      type: Number,
      default: 0
    },
    range: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 10
    },
    aux: {
      type: String,
      default: ''
    },
    showLastModification: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      name: window.name,
      source_type: null,
      reference: null,
      execute: null,
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      refresh: 60000,
      modalTitle: '',
      columns: [],
      data: [],
      max: 0,
      elements_results: [],
      last_update: '',
      padding_top: '20px'
    }
  },
  created: function () {
    this.getData()
  },
  methods: {
    formatEntry (value, limit) {
      if (limit === undefined) limit = 50
      if (value.length > limit) {
        return value.substring(0, limit) + '...'
      } else {
        return value
      }
    },
    imageName: function (column, value) {
      return `${column.path}/${value}.${column.extension}`;
    },
    numeralFormat: function (number) {
      return (Math.round(number * 100) / 100).toLocaleString()
    },
    getData: function () {
      let that = this
      if (that.show_last_modification) {
        that.padding_top = '0px'
      }
      if (that.source === undefined) {
        console.error('OwnTable Error - Source file not defined in component.')
        return
      }
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'

      let source = that.source
      if (that.range) {
        if (that.start > 0) source = source + '&start=' + that.start.toString()
        if (that.end > 0) source = source + '&end=' + that.end.toString()
      }
      source = source.replace('{$limit}', that.limit.toString())
      axios
        .get(baseURL + source)
        .then(function (response) {
          if (response.status === 200) {
            if (response.data.data === undefined) {
              console.error('OwnTable Error - data not defined in source file.')
              return
            }
            that.columns = response.data.columns
            that.data = response.data.data.slice(0, that.limit)
            that.$emit('finished', that.id, true, `Data Length: ${that.data.length}`)
            console.log('data', that.data)
            console.log('columns', that.columns)
          } else if (response.status === 404) {
            console.error('OwnTable Error - Source file not found.')
            that.$emit('finished', that.id, false, 'OwnTable Error - Source file not found.')
          }
        })
        .catch(function (error) {
          console.error('Error loading owntable widget file definition. Error:', error.response)
          that.$emit('finished', that.id, false, error.response)
          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('idToken')
            that.$router.push({ name: 'Home' })
          }
        })
    }
  }
}
</script>

<template>
  <div style="padding-right: 20px; padding-bottom: 20px; padding-left: 20px;" :style="{ 'padding-top': padding_top }">
    <span v-if="show_last_modification" class="widget_show_dates">Last Update: {{
      last_update.toLocaleString('en-GB').replace(',','') }}</span>
    <template v-if="data !== undefined && data.length > 0 && columns !== undefined && columns.length > 0">
      <table style="width:100%" class="mc_table">
        <thead>
          <th v-for="(column, index) in columns" :key="index">
            {{ column.name }}
          </th>
        </thead>
        <tbody>
          <tr v-for="(entry, index) in data" :key="index">
            <template v-if="columns !== undefined && columns.length > 0">
              <td v-for="(column, cindex) in columns" :key="cindex" :class="column.class" :width="column.width">
                <!-- {{ entry[column.reference] }} -->
                <template v-if="column.type === 'image'">
                  <img
                    :src="imageName(column, entry[column.reference])"
                    :width="column.image_width"
                  >
                </template>
                <template v-else-if="column.type === 'number'">
                  <span :class="column.class">
                    {{ numeralFormat(entry[column.reference]) }}
                  </span>
                </template>
                <template v-else-if="column.type === 'bar'">
                  <div
                    :style="getBarStyle(column, entry[column.reference])"
                    :class="entry['severity']"
                  />
                </template>
                <template v-else-if="column.type === 'multibar'">
                  <div style="display: flex; flex-direction: row; flex-wrap: nowrap; height:100%; width:100%;">
                    <div
                      v-for="(key, bindex) in column.keys"
                      :key="bindex"
                      :style="getMultiBarKey(column, entry, key)"
                    />
                  </div>
                </template>
                <template v-else-if="column.type === 'datetime'">
                  <template v-if="entry[column.reference] !== undefined && entry[column.reference] !== null">
                    {{ new Date(entry[column.reference]['$date']).toLocaleString() || 'N/A' }}
                  </template>
                </template>
                <template v-else-if="column.type === 'replace'">
                  <template v-if="entry[column.reference] !== undefined && entry[column.reference] !== null">
                    {{ column.replace[entry[column.reference]] }}
                  </template>
                </template>
                <template v-else-if="column.type === 'icon' && (entry[column.reference] !== undefined && entry[column.reference] !== null)">
                  <span :class="column.classes[entry[column.reference].split('_')[0]]">
                    <i
                      class="uil"
                      :class="column.icons[entry[column.reference].split('_')[0]]"
                      style="padding-top:3px;"
                    />&nbsp;
                  </span>
                </template>
                <template v-else>
                  <template v-if="entry[column.reference] !== undefined && entry[column.reference] !== null">
                    <span
                      :id="'id_' + entry[column.reference]"
                      :class="column.class"
                    >
                      {{ formatEntry(entry[column.reference] || "N/A", column.maxlength || 50 ) }}
                    </span>
                    <b-tooltip
                      :target="'id_' + entry[column.reference]"
                      triggers="hover"
                    >
                      {{ entry[column.reference] || "N/A" }}
                    </b-tooltip>
                  </template>
                </template>
              </td>
            </template>
            <template v-else />
          </tr>
        </tbody>
      </table>
    </template>
    <template v-else>
      <div id="multicolumn-empty">
        <span id="multicolumn-empty-span" class="short_widget">
          {{ error }}
        </span>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .mc_table {
    width: 100%;
    border: 1px;
    border-color: black;
    line-height: 18px !important;
  }

  .mc_table tr{
    height: 20px !important;
    border-top-color: #f0f0f0;
    border-top-width: 1px;
    border-top-style: solid;
    border-bottom-color: #f0f0f0;
    border-bottom-width: 1px;
    border-bottom-style: solid;
  }

  .normal {
    color: #D7DBE2;
    fill: #D7DBE2;
    background-color: #D7DBE2 !important;
    border: 0px !important;
  }

  .normal {
    color: #D7DBE2;
    fill: #D7DBE2;
    background-color: #D7DBE2 !important;
    border: 0px !important;
  }

  .high {
    color: #DC001E;
    /* fill: #DC001E; */
    /* background-color: #DC001E !important; */
    border: 0px !important;
  }

  .medium {
    color: #FECA00;
    /* fill: #FECA00; */
    /* background-color: #FECA00 !important; */
    border: 0px !important;
  }

  .low {
    color: #01AD00;
    /* fill: #01AD00; */
    /* background-color: #01AD00 !important; */
    border: 0px !important;
  }

  .reference {
    font-family: "Nunito Sans", sans-serif;
    font-size:0.95em;
  }

  .value {
    font-family: "Nunito Sans", sans-serif;
    font-size:0.95em;
  }

  .tleft {
    text-align: left;
  }

  .tcenter {
    text-align: center;
  }
</style>
